import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { isApiError, validationMessages } from '@/lib/api/errors'
import { tr } from './tr'

void i18n.use(initReactI18next).init({
  resources: { tr: { translation: tr } },
  lng: 'tr',
  fallbackLng: 'tr',
  interpolation: { escapeValue: false }, // React zaten kaçışlar
  returnNull: false,
})

export function errorMessage(code: string | undefined, serverMessage?: string, details?: unknown): string {
  const fromDetails = validationMessages(details)
  if (fromDetails.length) return fromDetails.join('\n')
  if (serverMessage?.trim()) return serverMessage
  if (code && i18n.exists(`errors.${code}`)) return i18n.t(`errors.${code}`)
  return i18n.t('errors.generic')
}

/** Toast / form hataları için: ApiError ise `error` alanındaki validation mesajlarını tercih eder. */
export function apiErrorMessage(e: unknown): string {
  if (isApiError(e)) return errorMessage(e.code, e.message, e.details)
  return i18n.t('errors.generic')
}

export default i18n
